import Vue from "vue"

import DateMixin from "./DateMixin"

Vue.mixin(DateMixin)
